// @core/api/endpoints/booking/list_booking_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBookingScheduleResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List booking schedule
 * Returns all booked entities of a specific booking type within a time range. Useful for viewing a provider's schedule across all bookings of a given type.
 */
export async function ListBookingSchedule(
  target_type: string,
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    sort?: string | number | boolean;
    time_max?: string | number | boolean;
    time_min?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListBookingScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/schedule`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  const requestOptions = options;
  return client.get<ListBookingScheduleResponse>(requestPath, { ...requestOptions, params });
}
